import Keycloak, { type KeycloakLoginOptions } from "keycloak-js";
import {
  KEYCLOAK_URL, KEYCLOAK_REALM, KEYCLOAK_CLIENT_ID,
  SILENT_CHECK_SSO_REDIRECT_PATH
} from "./cfg";
import { queryClient } from "../App";
import { DefaultService } from "../gen/howards-api/requests/services.gen";

const token_refresh_interval_s = 5 * 60 - 4;
let keycloak_initalized_resolver = (_initialize: boolean) => {};
export const keycloak_initialized: Promise<boolean> = new Promise(function (
  resolve,
  _,
) {
  keycloak_initalized_resolver = resolve;
});

export let keycloak: Keycloak | null = null;
export const get_token = () => keycloak?.token;

export const KEYCLOAK_RESET_CREDENTIALS_URL = `${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}/login-actions/reset-credentials?client_id=${KEYCLOAK_CLIENT_ID}`;

keycloak = new Keycloak({
  url: KEYCLOAK_URL,
  realm: KEYCLOAK_REALM,
  clientId: KEYCLOAK_CLIENT_ID,
});

let token_refresher: ReturnType<typeof setInterval> | undefined = undefined;
keycloak
  .init({
    onLoad: "check-sso",
    pkceMethod: "S256",
    silentCheckSsoRedirectUri: `${location.origin}/${SILENT_CHECK_SSO_REDIRECT_PATH}`,
    checkLoginIframe: true,
  })
  .then(function (authenticated) {
    if (authenticated) {
      console.log('User is authenticated');
    } else {
      console.log('User is NOT authenticated');
      keycloak.login();
    }
    // clear #.* symbols
    if (window) {
      window.history.pushState(
        "",
        document.title,
        window.location.pathname + window.location.search,
      );
    }
    keycloak_initalized_resolver(true);
    token_refresher = setInterval(async () => {
      try {
        await keycloak?.updateToken(5);
      } catch (_) {
        if (token_refresher) {
          clearInterval(token_refresher);
          token_refresher = undefined;
          logout();
        }
      }
    }, token_refresh_interval_s * 1000);
  })
  .catch(() => {
    console.log("initialization failed");
    keycloak_initalized_resolver(false);
  });

export const logout = async () => {
  if (!keycloak) {
    return;
  }
  await keycloak.logout();
  queryClient.invalidateQueries({ queryKey: ["User", "me"] });
};

export const login = (options?: KeycloakLoginOptions) => {
  if (keycloak) keycloak.login(options);
};
export const registration_url = async (
  options?: KeycloakLoginOptions,
): Promise<string> => {
  if (!keycloak) {
    return "";
  }
  return (await keycloak.createLoginUrl(options)).replace(
    "openid-connect/auth",
    "openid-connect/registrations",
  );
};

export const howards_api = DefaultService;